"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "contractServices",
    path: "/contract-services",
    component: "ContractServices"
});
let ContractServices = class ContractServices extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_dsParams = new core_1.ComponentValueCache(this, "dsParams", "ContractServices.dsParams");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    dsParams;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('integro_api/list_contract_service', {
            parameters: () => ({ ...this.dsParams, date: this.$fn.today() })
        });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                dsParams: {
                    skip_archived: true,
                },
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                    selectable: true,
                },
                b_2248226175642056_columns: [{
                        field: "contract_revision",
                        name: this.$fn.pgettext("Contract", "Contract number"),
                        params: {
                            sortPath: "contract_revision.contract_number",
                        },
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "contract_revision.contract_number",
                                        source: "row",
                                    },
                                },
                                {
                                    name: "routeLink",
                                    to: "contract",
                                    navigateOnIconClick: true,
                                    skipExport: true,
                                    params: {
                                        id: "contract_id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        id: "contract_type",
                        field: "contract_revision",
                        name: this.$fn.pgettext("Contracts", "Type"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "contract_type",
                                        source: "value",
                                    },
                                },
                                {
                                    name: "gettext",
                                    context: "ContractTypes",
                                    conversion: "StartCase",
                                    filterInput: true,
                                },
                                {
                                    name: "badge",
                                    variantMapSource: "inputValue",
                                    variantmap: {
                                        rental: "contract-type--rental",
                                        vendor: "contract-type--vendor",
                                        rental_agreement: "contract-type--rental_agreement",
                                        service: "contract-type--service",
                                        parking: "contract-type--parking",
                                        unknown: "contract-type--unknown",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        id: "contract_status",
                        field: "contract_revision",
                        name: this.$fn.pgettext("Contracts", "Status"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "status",
                                        source: "value",
                                    },
                                },
                                {
                                    name: "gettext",
                                    context: "ContractStatus",
                                    conversion: "StartCase",
                                    filterInput: true,
                                },
                                {
                                    name: "badge",
                                    variantMapSource: "fieldValue",
                                    variantmap: {
                                        draft: "light",
                                        approved: "success",
                                        signed: "success",
                                        active: "primary",
                                        ended: "warning",
                                        terminated: "warning",
                                        rescinded: "danger",
                                        archived: "light",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "rental",
                        name: this.$fn.pgettext("ContractServices", "Rental"),
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.name }}</strong>\n\
    {{~#if $value.house_number }} | {{ $value.house_number }}{{/if }}\n\
    {{~#if $value.area }} ({{$value.area}}{{$value.unit_of_area}}){{/if }}\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "rental",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "rental_id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "company",
                        name: this.$fn.pgettext("Contract", "Company"),
                        params: {
                            sortPath: "company.name",
                        },
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "company",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "company.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "counterparty",
                        name: this.$fn.pgettext("Contract", "Counterparty"),
                        params: {
                            sortPath: "counterparty.name",
                        },
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "company",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "counterparty.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "valid_from",
                        name: this.$fn.pgettext("Contracts", "Valid From"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "valid_to",
                        name: this.$fn.pgettext("Contracts", "Valid To"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "next_billing_due_date",
                        name: this.$fn.pgettext("Contracts", "Next Bill"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "next_indexation_date",
                        name: this.$fn.pgettext("Contracts", "Next Indexation Date"),
                        formatter: {
                            name: "date",
                        },
                    },
                    {
                        field: "name",
                        name: this.$fn.pgettext("ContractService", "Name"),
                        type: "command",
                    },
                    {
                        field: "invoice_notes",
                        name: this.$fn.pgettext("ContractService", "Invoice notes"),
                    },
                    {
                        field: "billing_category",
                        name: this.$fn.pgettext("ContractService", "Billing category"),
                    },
                    {
                        field: "invoice_group_id",
                        name: this.$fn.pgettext("ContractService", "Invoice group"),
                    },
                    {
                        field: "description",
                        name: this.$fn.pgettext("ContractService", "Description"),
                    },
                    {
                        field: "intermediated_service",
                        name: this.$fn.pgettext("ContractService", "Intermediated service"),
                        formatter: "checkbox",
                    },
                    {
                        field: "billing_frequency",
                        name: this.$fn.pgettext("ContractService", "Billing frequency"),
                    },
                    {
                        field: "billing_currency",
                        name: this.$fn.pgettext("ContractService", "Billing currency"),
                    },
                    {
                        field: "billing_date_rule",
                        name: this.$fn.pgettext("ContractService", "Billing date"),
                        formatter: {
                            name: "template",
                            engine: "hb",
                            format: "<span>\n\
  {{~#if $value }}\n\
    {{~#if $value.description }}\n\
      {{ $value.description }}\n\
    {{ else }}\n\
      {{~#if $value.anchor }}{{ $value.anchor }}{{/if }}\n\
      {{~#if $value.offset_days }}\n\
        {{ $value.offset_days }}\n\
      {{/if }}\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
                        },
                    },
                    {
                        field: "due_date_rule",
                        name: this.$fn.pgettext("ContractService", "Due date"),
                        formatter: {
                            name: "template",
                            engine: "hb",
                            format: "<span>\n\
  {{~#if $value }}\n\
    {{~#if $value.description }}\n\
      {{ $value.description }}\n\
    {{ else }}\n\
      {{~#if $value.anchor }}{{ $value.anchor }}{{/if }}\n\
      {{~#if $value.offset_days }}\n\
        {{ $value.offset_days }}\n\
      {{/if }}\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
                        },
                    },
                    {
                        field: "exchange_rate_date_rule",
                        name: this.$fn.pgettext("ContractService", "Exchange rate date"),
                        formatter: {
                            name: "template",
                            engine: "hb",
                            format: "<span>\n\
  {{~#if $value }}\n\
    {{~#if $value.anchor }}{{ $value.anchor }}{{/if }}\n\
    \n\
    {{~#if $value.description }}{{ $value.description }}{{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
                        },
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Contract services"),
                icon: this.$config.contract.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_6954_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_6956_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_showModal_6958_getActionArgs($event) {
        return {
            name: "ContractService",
            props: {
                modal: true,
                oid: $event.data.data.id,
            },
        };
    }
    async evh_2248226175642056_command_6957_getWhen($event) {
        return $event.data.column.id === 'name';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    async act_4440454779651433_reloadSlickgrid_6962_getActionArgs($event) {
        return {
            grid: "contractServices",
        };
    }
    async evh_4440454779651433_close_6961_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_4440454779651433_showModal_6960_getActionArgs($event) {
        return {
            name: "BulkContractServiceEditor",
            props: {
                items: this.selectedItems,
            },
        };
    }
    async evh_4440454779651433_click(event, scope) {
        return await this.actions.evh_4440454779651433_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_6954 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_6954_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_6953 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_6954,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_6953],
        });
        const act_2248226175642056_setData_6956 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_6956_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_6955 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_6956,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_6955],
        });
        const act_2248226175642056_showModal_6958 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_6958_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_6957 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_6958,
            event: "command",
            when: this.evh_2248226175642056_command_6957_getWhen,
            displayName: "showModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_6957],
        });
        const act_4440454779651433_reloadSlickgrid_6962 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_4440454779651433_reloadSlickgrid_6962_getActionArgs,
            events: [],
        });
        const evh_4440454779651433_close_6961 = new core_1.actions.EventHandlerImpl({
            action: act_4440454779651433_reloadSlickgrid_6962,
            event: "close",
            when: this.evh_4440454779651433_close_6961_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_4440454779651433_showModal_6960 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_4440454779651433_showModal_6960_getActionArgs,
            events: [evh_4440454779651433_close_6961],
        });
        const evh_4440454779651433_click_6959 = new core_1.actions.EventHandlerImpl({
            action: act_4440454779651433_showModal_6960,
            event: "click",
            displayName: "showModal",
        });
        const evh_4440454779651433_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4440454779651433_click_6959],
        });
        return {
            act_7315092382398562_closeModal_6954,
            evh_7315092382398562_close_6953,
            evh_7315092382398562_close,
            act_2248226175642056_setData_6956,
            evh_2248226175642056_selectedRowsChanged_6955,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_showModal_6958,
            evh_2248226175642056_command_6957,
            evh_2248226175642056_command,
            act_4440454779651433_reloadSlickgrid_6962,
            evh_4440454779651433_close_6961,
            act_4440454779651433_showModal_6960,
            evh_4440454779651433_click_6959,
            evh_4440454779651433_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], ContractServices.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractServices.prototype, "onSize", null);
ContractServices = __decorate([
    (0, vue_property_decorator_1.Component)()
], ContractServices);
exports.default = ContractServices;
vue_property_decorator_1.Vue.component("ContractServices", ContractServices);
